import { PropsWithChildren } from 'react';
import { Link, LinkProps } from '@mui/material';

type LinkCellProps = PropsWithChildren<LinkProps>;

export const ButtonLinkCell = ({ children, ...rest }: LinkCellProps) => {
  return (
    <Link
      component="button"
      variant="body2"
      sx={{
        width: '100%',
        height: '100%',
        textAlign: 'left',
      }}
      {...rest}
    >
      {children}
    </Link>
  );
};
